/** 主辦需求設備：固定選項，儲存以換行分隔（供 webhook / n8n 切開） */
export const EQUIPMENT_NEED_OPTIONS = ['KTV機', '桌遊', '投影機', '其他'];

export function parseEquipmentNeed(raw) {
  const lines = String(raw || '')
    .split(/[\n\r、，,]+/)
    .map((s) => s.trim())
    .filter(Boolean);
  const selected = [];
  const otherParts = [];
  for (const line of lines) {
    if (line === '其他' || /^其他[：:]/.test(line)) {
      if (!selected.includes('其他')) selected.push('其他');
      const m = line.match(/^其他[：:]\s*(.*)$/);
      if (m && m[1].trim()) otherParts.push(m[1].trim());
      continue;
    }
    if (EQUIPMENT_NEED_OPTIONS.includes(line)) {
      if (!selected.includes(line)) selected.push(line);
      continue;
    }
    if (!selected.includes('其他')) selected.push('其他');
    otherParts.push(line);
  }
  return { selected, otherText: otherParts.join('；') };
}

export function serializeEquipmentNeed(selected, otherText) {
  const set = new Set(Array.isArray(selected) ? selected : []);
  const lines = [];
  for (const opt of EQUIPMENT_NEED_OPTIONS) {
    if (!set.has(opt)) continue;
    if (opt === '其他') {
      const t = String(otherText || '').trim();
      lines.push(t ? `其他：${t}` : '其他');
    } else {
      lines.push(opt);
    }
  }
  return lines.join('\n');
}
